import { MapPin, Sparkles, Receipt, Puzzle, ShieldCheck } from "lucide-react";

/**
 * Elegant, subtle info section that lists important pricing hints
 * with icons in the Wertbild design language.
 *
 * Props:
 *   hints – array of { icon, text }
 *   title – optional overline / title
 */
export default function PricingHints({ hints = [], title = "Gut zu wissen" }) {
  return (
    <section className="py-20 md:py-24 border-t border-[#EAE6DE]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-4 reveal">
            <div className="overline mb-4">Transparenz</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[#1A1A1A] tracking-tight">
              <span className="italic gold-text">{title}</span>.
            </h2>
          </div>

          <div className="md:col-span-8 reveal">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
              {hints.map((h, i) => (
                <li key={i} className="flex items-start gap-4">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#FFA500] shrink-0">
                    <h.icon size={16} className="text-[#1A1A1A]" strokeWidth={1.8} />
                  </span>
                  <p className="text-[14px] leading-[1.55] text-[#1A1A1A] font-light pt-1">
                    {h.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

// Shared icons for consumer components
export const HINT_ICONS = { MapPin, Sparkles, Receipt, Puzzle, ShieldCheck };
